import { isNil } from './is-nil';
import { Subscription } from 'rxjs';

/**
 * Subscription Manager to manage multiple active subscriptions and unsubscribe from all of them at once.
 *
 * @example const sm = new SubscriptionManager();
 */
export class SubscriptionManager {
  private readonly subscriptions: Subscription[] = [];

  /**
   * Use to add a subscription to the Subscription Manager.
   *
   * @example sm.manage = observable$.subscribe(observer)
   */
  set manage(value: Subscription) {
    if (isNil(value) || this.subscriptions.includes(value)) {
      return;
    }

    this.subscriptions.push(value);
  }

  /**
   * Unsubscribes from all the managed subscriptions and removes them from the Subscription Manager. Useful when called at the end of a component's lifecycle to prevent memory leaks in your application.
   *
   * @example
   * ngOnDestroy() {
   *  this.sm.unsubscribe();
   * }
   */
  unsubscribe() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
